import { QUIET_CARD_VIDEO_URL, useReducedMotion } from "@healthos/ui";
import { useEffect } from "react";
import { preloadQuietCardVideo } from "../lib/media-preload";

export function ContactCentreWaves() {
  const prefersReducedMotion = useReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) return;
    void preloadQuietCardVideo({ timeoutMs: 4_000 });
  }, [prefersReducedMotion]);

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {prefersReducedMotion ? null : (
        <video
          autoPlay
          className="absolute inset-0 h-full w-full object-cover"
          loop
          muted
          playsInline
          preload="auto"
          src={QUIET_CARD_VIDEO_URL}
          tabIndex={-1}
        />
      )}
      <span className="absolute inset-0 bg-teal-700/10" />
      <span
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 70% 55% at 50% 46%, color-mix(in srgb, var(--color-cream-warm) 72%, transparent) 0%, color-mix(in srgb, var(--color-cream-warm) 38%, transparent) 42%, color-mix(in srgb, var(--color-cream-warm) 18%, transparent) 68%, transparent 100%)",
        }}
      />
      <span
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, color-mix(in srgb, var(--color-cream-warm) 46%, transparent) 0%, transparent 28%, transparent 62%, color-mix(in srgb, var(--color-cream-warm) 58%, transparent) 100%)",
        }}
      />
    </div>
  );
}
